import React, { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { PersonCircle } from 'react-bootstrap-icons';
import './about.css';
import PublicHeader from '../Header/PublicHeader';
import Footer from '../Footer';
import RituImg from "../../Assets/img/Testimonials/Ritu Goel.jpeg"
import pkImg from '../../Assets/img/Board/PK Joseph board.jpg'
import narenImg from '../../Assets/img/Board/Naren Verma board.jpg'
import BhoomikaImg from "../../Assets/img/Testimonials/Bhoomika Padhalni.jpg"
import mohiniImg from '../../Assets/img/Board/Mohini board.jpg'
import indrajitImg from '../../Assets/img/Board/Indrajit Ghosh board.png'
import bhavyaImg from '../../Assets/img/Board/Bhavya board.png'
import amanImg from '../../Assets/img/Board/Amandeep board.JPG'
import SikhaImg from "../../Assets/img/Testimonials/Shikha Saboo1.jpg"
import AniImg from "../../Assets/img/Testimonials/Ani Titus.jpg"
import kirtiImg from '../../Assets/img/Board/Kirti Mehta.jpeg'
import PragatiImg from '../../Assets/img/Testimonials/Pragati.jpg'
import kavitaImg from '../../Assets/img/Testimonials/Kavita Soni.jpg'

const committeesData = [
  {
    committee: "Organising Committee",
    members: [
      { name: "PK Joseph", role: "Chairman",img: pkImg },
      { name: "Amandeep Singh Bhachu",role: "Vice Chairman", img: amanImg },
      { name: "Naren",role: "Chief Strategist" ,img: narenImg },
      { name: "Mohini Piyush Mathijia", role: "Sponsorships" ,img: mohiniImg },
      { name: "Indrajit Ghosh", role: "Publicity" ,img: indrajitImg },
      { name: "Bhavya Singh J", role: "Invitations" ,img: bhavyaImg },
      { name: "Ritu Goel", role: "Award & Recognition" ,img: RituImg },
      { name: "Bhoomika Padhalini", role: "Members Engagement" ,img: BhoomikaImg },
      { name: "Shikha Saboo", role: "Agenda" ,img: SikhaImg },
      { name: "Ani Titus", role: "Marketing" ,img: AniImg },
      { name: "Pragati Imam",role: "Institutional Visits" ,img: PragatiImg },
      { name: "Kirti Mehta", role: "Registrations" ,img: kirtiImg },
      { name: "Kavita Soni", role: "Institutional Visits" ,img: kavitaImg },
    ]
  },
] 

const CommitteeMemberCard = ({ member, isActive, onHover, onLeave, isHead }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      className={`card border-0 rounded-lg overflow-hidden ${isActive ? 'active' : ''}`}
      onMouseEnter={() => {
        setIsHovered(true);
        onHover();
      }}
      onMouseLeave={() => {
        setIsHovered(false);
        onLeave();
      }}
      style={{
        transition: 'all 0.4s ease',
        transform: isHovered ? 'translateY(-8px)' : 'translateY(0)',
        boxShadow: isHovered ? '0 22px 40px rgba(0,0,0,0.15)' : '0 5px 15px rgba(0,0,0,0.08)',
        width: '100%',
        minHeight: '300px',
        cursor: 'pointer'
      }}
    >
      <div className="card-body p-4 text-center">
      <div className="d-flex justify-content-center align-items-center mb-3" style={{ height: '180px' }}>
  {member.img ? (
    <img src={member.img} alt={member.name} style={{ height: '100%', width: '180px', borderRadius:"50%"}} />
  ) : (
    <PersonCircle size={100} className="text-secondary opacity-50" />
  )}
</div>
        <h4 className="fw-bold card-position">{member.name}</h4>
        {member.role && (
          <span className="d-block" style={{ color: '#5d89ba', fontWeight: '600' }}>
            {member.role}
          </span>
        )}
      </div>

      {/* Description below Head card on hover */}
      {isHovered && isHead && member.description && (
        <div
          className="p-3 bg-light text-center"
          style={{
            borderTop: '1px solid #ddd',
            transition: '0.3s',
            opacity: isHovered ? 1 : 0
          }}
        >
          <p className="m-0 leading-relaxed text-justify mx-auto" style={{ textWrap: 'pretty' }}>{member.description}</p>
        </div>
      )}
    </div>
  );
};

const CommitteeSection = ({ committee }) => {
  const [activeCard, setActiveCard] = useState(null);

  const head = committee.members.find(member => member.name === 'PK Joseph');
  const members = committee.members.filter(member => member.name !== 'PK Joseph');

  // 🔥 Dynamically center-align rows with fewer than 4 cards
  const getRowAlignment = (count) => {
    if (count === 1) return 'justify-content-center';
    if (count === 2 || count === 3) return 'justify-content-center';
    return '';
  };

  return (
    <div className="committee-section mb-5">
      <div className="committee-header text-center mb-4">
        <h2 className="fw-bold" style={{ fontSize: '2rem', color: '#2a4b7c' }}>
          {committee.committee}
        </h2>
        <div className="board-divider" style={{ width: '200px', height: '3px' }}></div>
      </div>

      {/* Head card centered */}
      <Row className="justify-content-center mb-4">
        {head && (
          <Col xs={12} sm={8} md={6} lg={4}>
            <CommitteeMemberCard
              member={head}
              isActive={activeCard === 'head'}
              onHover={() => setActiveCard('head')}
              onLeave={() => setActiveCard(null)}
              isHead={true}
            />
          </Col>
        )}
      </Row>

      {/* Member cards */}
      <Row className={`g-4 ${getRowAlignment(members.length)}`}>
        {members.map((member, idx) => (
          <Col key={idx} xs={12} sm={6} md={4} lg={3}>
            <CommitteeMemberCard
              member={member}
              isActive={activeCard === idx}
              onHover={() => setActiveCard(idx)}
              onLeave={() => setActiveCard(null)}
              isHead={false}
            />
          </Col>
        ))}
      </Row>
    </div>
  );
};

const OrganisingTeam = () => {
  return (
    <>
      <PublicHeader />
      <div className="section-header md:mt-[40px] mt-0">
        <div className="header-content px-3">
          <h1 className="text-2xl sm:text-3xl md:text-5xl font-bold mb-2 text-white">All India Convention of Career Counsellors & Awards</h1>
          
        </div>
        <div className="overlay"></div>
      </div>

      <Container className="py-5">

        {committeesData.map((committee, idx) => (
          <CommitteeSection key={idx} committee={committee} />
        ))}
      </Container>

      <Footer />
    </>
  );
};

export default OrganisingTeam;
